import { forwardRef } from 'react';
import { useLayersDrawerState } from 'features/mapping/hooks/useLayersDrawerState';
import { LegendDrawerContent } from 'features/mapping/components/LegendDrawerContent';
import { LayerGroups } from './LayerGroups';

export const DrawerContent = forwardRef<HTMLDivElement>(
  (_, ref): JSX.Element | null => {
    const { menu } = useLayersDrawerState();

    if (menu === 'legend') {
      return <LegendDrawerContent ref={ref} />;
    }

    if (menu === 'layers') {
      return <LayerGroups ref={ref} />;
    }

    return null;
  },
);

DrawerContent.displayName = 'DrawerContent';
